import React from "react";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Stop } from "@material-ui/icons";

export type ErrorModalProps = {
    errorMessage: string | null;
    onClose: () => void;
};

export function ErrorModal({ errorMessage, onClose }: ErrorModalProps) {
    let errorText: string;

    if (errorMessage === null) {
        throw new Error(
            "ErrorModal must have either an error or an errorMessage"
        );
    } else {
        console.log({
            "ErrorModal errorMessage": errorMessage,
        });
        errorText =
            errorMessage ??
            "An unforseen error occured, Please contact support @ https://www.efilemadeeasy.com/support/";
    }

    const [message, setMessage] = useState(errorText);

    return (
        <>
            <Modal show={true} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ color: "red" }}>
                        <Stop />
                        Uh-Oh!
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <div className="mt-2">
                                <h5 className="font-14 mb-3">{message}</h5>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={onClose}
                        style={{ float: "right" }}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
